import { useSyncExternalStore } from 'use-sync-external-store/shim';

export type WsConnectionStatus = 'connecting' | 'connected' | 'disconnected';

export interface WsStatus {
  status: WsConnectionStatus;
  error: string | null;
}

let state: WsStatus = { status: 'connecting', error: null };
const listeners = new Set<() => void>();

const notify = () => listeners.forEach(l => l());

export const setWsStatus = (patch: Partial<WsStatus>) => {
  state = { ...state, ...patch };
  notify();
};

export const useWsStatus = () =>
  useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    () => state,
  );
